import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'quizzes';

const list = (userId: string, params: any) => EndPointService.get(`/${ROUTE}/user/${userId}`, params);

export default {
    list,
};
